module.exports = "https://cdn-skillquest.mathletics.com/app/190/assets/images/3e1d50ce5c43cd64b5da3bb1ee0e2683.svg";